<template>
  <div class="container mescroll-touch">
    <div class="navigationBar">
      <div class="nav-left">
        <img class="arrow-left" @click="goback" src="@/assets/images/arrow-left.png" />
      </div>
      <div class="nav-title">{{ title }}</div>
      <div class="nav-right" @click="generatePoster"> 
        <span>分享</span>
        <img src="@/assets/images/share_icon.png" />
      </div>
    </div>
    <div class="details">
      <div class="moduleBox" v-for="module in moduleList" :key="module.Id">
        <div class="titleBox" v-if="module.Title">{{ module.Title }}</div>
        <!-- 轮播图 -->
        <div class="swipeBox" v-if="module.Type == 1">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#CA001B">
            <van-swipe-item v-for="item in module.List" :key="item.Id" @click="bannerClick(item)">
              <img class="banner" :src="item.FileUrl" alt="" srcset="">
            </van-swipe-item>
          </van-swipe>
        </div>

        <!-- 富文本框 -->
        <div class="richtextBox" v-if="module.Type == 2" v-html="module.UeditorContent"></div>

        <!-- 横版内容 -->
        <div class="horizontalBox" v-if="module.Type == 3">
          <swiper class="horizontalSwiper" ref="horizontalSwiper" :options="swiperOptions" @click="(event) => handleSwiperClick(event, module.List)">
            <swiper-slide v-for="item in module.List" :key="item.Id">
              <img :src="item.FileUrl" alt="" srcset="">
            </swiper-slide>
          </swiper>
          <div class="viewMore" v-if="module.IsMore" @click="viewMore(module.Id)">查看更多<van-icon name="arrow" /></div>
        </div>

        <!-- 竖版双排 -->
        <div class="doubleRowList" v-if="module.Type == 4 && module.ArrangeType == 2">
          <div class="list">
            <div class="listItem" v-for="(item, index) in module.List" :key="index" @click="contentClick(item)">
              <img class="cover" :src="item.FileUrl" />
              <div class="info">
                <p class="title van-multi-ellipsis--l2">{{ item.Title }}</p>
                <p class="time" v-if="item.ArtType == 3">{{ item.StratTime }}</p>
                <div class="doctorInfo" v-if="item.SpeakerName">
                  <img src="@/assets/images/headSculpture1.png" />
                  <span class="doctorName">{{ item.SpeakerName }}</span>
                  <span class="hospital van-ellipsis">{{ item.SpeakerHospital }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="viewMore" v-if="module.IsMore" @click="viewMore(module.Id)">查看更多<van-icon name="arrow" /></div>
        </div>

        <!-- 竖版单排 -->
        <div class="singleRowList" v-if="module.Type == 4 && module.ArrangeType == 1">
          <div class="listItem" v-for="(item, index) in module.List" :key="index" @click="contentClick(item)">
            <img class="cover" :src="item.FileUrl" />
            <div class="info">
              <p class="title van-ellipsis">{{ item.Title }}</p>
            </div>
          </div>
          <div class="viewMore" v-if="module.IsMore" @click="viewMore(module.Id)">查看更多<van-icon name="arrow" /></div>
        </div>
        
        <!-- 金刚区 -->
        <div class="iconBox" v-if="module.Type == 5">
          <div class="iconItem" v-for="(item, index) in module.List" :key="index" @click="columnsClick(item)">
            <img :src="item.FileUrl" />
            <span>{{item.Title}}</span>
          </div>
        </div>
      </div>
    </div>
    <van-popup class="PosterPopup" v-model="PosterShow" :close-on-click-overlay="false" @opened="generateImageOpened">
        <div class="close" @click="PosterShow = false">
          <van-icon class="closeIcon" name="cross" />
        </div>
        <div class="PosterBox">
          <div class="generateImageBox" ref="generateImageBox" v-if="!PosterPhoto">
            <img class="PosterImg" v-if="cover" :src="cover" />
            <div class="QrcodeBox">
              <img class="QrcodeFont" src="@/assets/images/font1.png" />
              <img class="Qrcode" crossOrigin="anonymous" v-if="QRCode" :src="QRCode" />
              <img class="QrcodeFont" src="@/assets/images/font2.png" />
            </div>
          </div>
          <img class="PosterPhoto" v-else :src="PosterPhoto" alt="">
          <p class="tips">请长按保存图片到手机后转发</p>
        </div>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import html2canvas from 'html2canvas';
import mixin from '../../common/mixin/mixins'
import { mapState } from "vuex";
export default {
  name: 'ZoneDetails',
  data() {
    return {
      hasPath: '',
      title: '',
      moduleList: [],
      swiperOptions: {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        simulateTouch: true,
        touchRatio: 1,
        speed: 500,
        effect: 'slide',
        slideToClickedSlide: true,
      },
      PosterShow: false,
      cover: '',
      QRCode: '',
      PosterPhoto: ''
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
    id() {
      return this.$route.query.id
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  created() {
    // this.getZoneDetails();
  },
  activated() {
    this.getZoneDetails();
    this.enter();
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    enter() {
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: 0,
        ZDId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 1,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        if (!this.timer && res.Data != 0) {
          this.timer = setInterval(() => {
            this.$axios.post("/Api/Api/Web/Article/ABUpdateTime?id=" + res.Data).then(() => {});
          }, 10000);
        }
      });
    },
    getZoneDetails() {
      let toast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.$axios.post('/Api/Api/Web/Zone/GetZD', {
        ZDId: this.id
      }).then(res => {
        let data = res.Data;
        this.title = data.Title;
        this.QRCode = data.QrCode;
        this.moduleList = data.zd ? data.zd : [];
        const firstBanner = this.moduleList.find(item => item.Type == 1);
        if(firstBanner && firstBanner.List.length > 0) {
          this.cover = firstBanner.List[0].FileUrl;
        } else {
          this.cover = require('@/assets/images/cover.jpg');
        }

        wx.miniProgram.postMessage({
          data: {
            share: {
              title: this.title,
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/zoneDetails?id=${this.$route.query.id}&sourceType=7`)}`,
              contentId: ''
            }
          }
        })

        toast.clear();
      });
    },
    bannerClick(info) {
      if(info.LinkType && info.LinkUrl) {
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.LinkUrl)) {
            location.href = info.LinkUrl;
          } else {
            this.$router.push(info.LinkUrl);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.LinkUrl})
        } else if(info.LinkType == 3) {
          if (info.LinkUrl.indexOf('?') !== -1) {
            info.LinkUrl += '&sourceType=13&sourceId=' + info.Id;
          } else {
            info.LinkUrl += '?sourceType=13&sourceId=' + info.Id;
          }
          this.$router.push(info.LinkUrl);
        }
        this.BuriedPoint(3, info.Title ? info.Title : '', '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''));
      }
    },
    columnsClick(info) {
      if(info.LinkType && info.LinkUrl) {
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.LinkUrl)) {
            location.href = info.LinkUrl;
          } else {
            this.$router.push(info.LinkUrl);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.LinkUrl})
        } else if(info.LinkType == 3) {
          if (info.LinkUrl.indexOf('?') !== -1) {
            info.LinkUrl += '&sourceType=14&sourceId=' + info.Id;
          } else {
            info.LinkUrl += '?sourceType=14&sourceId=' + info.Id;
          }
          this.$router.push(info.LinkUrl);
        }
        this.BuriedPoint(1, info.Title ? info.Title : '', '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''));
      }
    },
    contentClick(info) {
      if(info.Type == 1 && info.LinkUrl) {
        location.href = info.LinkUrl;
      } else if (info.Type == 2) {
        if(info.ArtType == 1 || info.ArtType == 2) {
          this.$router.push({
            path: 'contentPage',
            query: {
              id: info.ArtId,
              type: info.ArtType,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(info.ArtType == 3) {
          this.$router.push({
            path: 'liveDetails',
            query: {
              id: info.ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(info.ArtType == 4) {
          this.$router.push({
            path: 'activityDetails',
            query: {
              id: info.ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        }
      }
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/home');
        return;
      }
      this.$router.go(-1);
    },
    handleSwiperClick(swiper, list) {
      const realIndex = swiper.realIndex
      console.log(realIndex, list);
      if(list[realIndex].Type == 1 && list[realIndex].LinkUrl) {
        location.href = list[realIndex].LinkUrl;
      } else if (list[realIndex].Type == 2) {
        if(list[realIndex].ArtType == 1 || list[realIndex].ArtType == 2) {
          this.$router.push({
            path: 'contentPage',
            query: {
              id: list[realIndex].ArtId,
              type: list[realIndex].ArtType,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(list[realIndex].ArtType == 3) {
          this.$router.push({
            path: 'liveDetails',
            query: {
              id: list[realIndex].ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(list[realIndex].ArtType == 4) {
          this.$router.push({
            path: 'activityDetails',
            query: {
              id: list[realIndex].ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        }
      }
    },
    viewMore(moduleId) {
      this.$router.push({
        path: 'zoneMoreList',
        query: {
          zoneDetailsId: this.id,
          id: moduleId
        }
      });
    },
    generatePoster() {
      this.imageUrls = this.cover;
      this.PosterShow = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: 0,
        ZDId: this.id,
        CustomerId: this.userInfo.Id,
        Type: 11,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {});
    },
    generateImageOpened() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      
      // 等待所有图片加载完成
      this.$nextTick(async () => {
        const images = this.$refs.generateImageBox.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // 即使出错也继续
            }
          });
        });
        
        try {
          // 等待所有图片加载（或出错）
          await Promise.all(imagePromises);
          
          // 给一个延迟确保 DOM 稳定
          await new Promise(resolve => setTimeout(resolve, 500));
          
          html2canvas(this.$refs.generateImageBox, {
            useCORS: true,
            allowTaint: true, // 允许 tainted canvas
            backgroundColor: null, // 透明背景
            scale: 2, // 提高清晰度
          }).then((canvas) => {
            this.PosterPhoto = canvas.toDataURL("image/png");
            toast.clear();
          }).catch(error => {
            console.error('html2canvas 错误:', error);
            toast.clear();
            this.$toast('生成海报失败，请重试');
          });
          
        } catch (error) {
          toast.clear();
          console.error('图片等待错误:', error);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
}
.navigationBar {
  display: flex;
  align-items: center;
  height: 50px;
  box-sizing: border-box;
  background-color: #F3F3F3;
  box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 6px 0px;
  .nav-left {
    width: 80px;
    .arrow-left {
      display: block;
      width: 22px;
      margin-left: 15px;
    }
  }
  .nav-title {
    flex: 1;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nav-right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 28px;
    font-size: 13px;
    color: #FFFFFF;
    background-color: #EB1701;
    border-radius: 25px 0 0 25px;
    padding: 0 6px;
    box-sizing: border-box;
    img {
      display: block;
      width: 12px;
      margin-left: 6px;
    }
  }
}
.details {
  flex: 1;
  padding: 15px 0 0;
  overflow: auto;
  .moduleBox {
    .titleBox {
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: #FFFFFF;
      background: url('../../assets/images/title_bg.png');
      background-size: 100% 100%;
      margin: 0 15px 10px;
    }
    .swipeBox {
      margin: 0 15px 15px;
      border-radius: 12px;
      overflow: hidden;
      .banner {
        display: block;
        width: 100%;
      }
    }
    .richtextBox {
      margin: 0 15px 15px;
    }
    /deep/ .richtextBox > p > img {
      width: 100%;
    }
    /deep/ .richtextBox img {
      width: 100%;
    }
    .horizontalBox {
      margin-bottom: 15px;
      overflow: hidden;
    }
    .horizontalSwiper {
      padding: 0 15px;
      overflow: visible;
      ::-webkit-scrollbar {
        display: none;
      }
      ::v-deep .swiper-slide {
        width: 60%;
        margin: 0 auto;
        transition: transform 0.3s, opacity 0.3s;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
        border-radius: 12px;
        img {
          display: block;
          width: 100%;
          object-fit: cover;
          border-radius: 12px;
        }
      }
      ::v-deep .swiper-slide:not(.swiper-slide-active) {
        transform: scale(0.9);
      }
    }
    .doubleRowList {
      margin: 0 15px 15px;
      .list {
        // display: flex;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px; /* 间距统一 */
        .listItem {
          display: flex;
          flex-direction: column;
          // width: calc(calc(100% / 2) - 5px);
          background-color: #FFFFFF;
          border-radius: 10px;
          overflow: hidden;
          .cover {
            display: block;
            width: 100%;
          }
          .info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 5px;
            .title {
              font-size: 12px;
              color: #1A1200;
            }
            .time {
              font-size: 10px;
              color: #898989;
              margin-top: 3px;
            }
            .doctorInfo {
              display: flex;
              align-items: center;
              border-top: 1px solid #D8D8D8;
              margin-top: 5px;
              padding-top: 5px;
              font-size: 10px;
              img {
                display: block;
                width: 20px;
              }
              .doctorName {
                white-space: nowrap;
                color: #373737;
                margin: 0 4px;
              }
              .hospital {
                color: #7A7A7A;
              }
            }
          }
        }
        // .listItem:not(:nth-last-child(-n+2)) {
        //   margin-bottom: 10px;
        // }
        // .listItem:nth-child(even) {
        //   margin-left: 10px;
        // }
      }
    }
    .singleRowList {
      margin: 0 15px 15px;
      .listItem {
        position: relative;
        border-radius: 12px;
        overflow: hidden;
        .cover {
          display: block;
          width: 100%;
        }
        .info {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 30px 10px 10px;
          background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
          color: #FFFFFF;
          .title {
            font-size: 12px;
            text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
          }
        }
      }
      .listItem:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
    .viewMore {
      font-size: 12px;
      color: #EB1701;
      text-align: center;
      margin-top: 6px;
    }
    .iconBox {
      display: flex;
      margin: 0 15px 15px;
      .iconItem {
        flex: 1;
        text-align: center;
        img {
          display: block;
          margin: 0 auto 5px;
          width: 45px;
          height: 45px;
        }
        span {
          font-size: 12px;
          color: #3D3D3D;
        }
      }
    }
  }
}

.PosterPopup {
  width: 90%;
  height: 350px;
  border-radius: 14px;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.PosterBox {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 14px;
  .generateImageBox {
    padding-bottom: 10px;
  }
  .PosterImg {
    display: block;
    width: 100%;
  }
  .QrcodeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .QrcodeFont {
      width: 60px;
    }
  }
  .Qrcode {
    display: block;
    width: 100px;
    margin: 0 30px ;
  }
  .PosterPhoto {
    display: block;
    width: 100%;
  }
  .tips {
    font-size: 13px;
    color: #333333;
    margin: 0 0 18px;
    text-align: center;
  }
}
</style>